(function ($) {

    $(document).ready(function () {
        $('.image-thumbnails-wrapper').each(function () {

            let flexsliderContainer = $(this);

            // make sure we have what we need to continue
            // this prevent js issues which causes problems when exiting edit mode
            // if (typeof flexslider === "undefined" || flexsliderContainer.length <= 0) {
            //     return;
            // }

            let imageDisplay = flexsliderContainer.find('.image-display');
            let carousel = flexsliderContainer.find('.carousel');

            // The slider being synced must be initialized first
            carousel.flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: false,
                slideshow: false,
                itemWidth: 210,
                itemMargin: 5,
                asNavFor: '#' + imageDisplay.prop('id')
            });

            imageDisplay.flexslider({
                animation: "fade",
                controlNav: false,
                animationLoop: false,
                slideshow: false,
                sync: "#" + carousel.prop('id')
            });
        });
    });

})(jQuery);
